module.exports = __webpack_public_path__ + "img/video-14.9745cbfa.png";